module.exports = __webpack_public_path__ + "static/media/kakaotalk-icon.6512d1bf.png";